export const API_URL = process.env.REACT_APP_API_URL;
export const STUDIO_URL = process.env.REACT_APP_STUDIO_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
